module.exports = __webpack_public_path__ + "img/tree3.643a9cc.svg";